import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-prompt',
  templateUrl: './prompt.page.html',
  styleUrls: ['./prompt.page.scss'],
})
export class PromptPage {
  @Input() color = 'primary';
  @Input() title: string;
  @Input() placeholder?: string = undefined;
  @Input() value?: string = undefined;
  @Input() negativeButtonText = 'Cancelar';
  @Input() positiveButtonText = 'Ok';

  constructor(public modalController: ModalController) {}
}
